import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

/**
 * A headline metric, laid out as a uniform cell in a de-boxed strip: a big number,
 * a label, and an optional short caption. No box, no icon — several of these sit in
 * a flex/grid row with hairline dividers so a metric row reads clean and even.
 * Used for top-level counts ("code bases", "clouds", "cost", billing figures).
 */
export function Stat({
  value,
  label,
  sub,
  accent = false,
  className,
}: {
  value: ReactNode;
  label: string;
  sub?: ReactNode;
  accent?: boolean;
  className?: string;
}) {
  return (
    <div className={cn('min-w-0', className)}>
      <div
        className={cn(
          'font-display text-3xl font-bold leading-none tracking-tight',
          accent ? 'text-iris' : 'text-bone',
        )}
      >
        {value}
      </div>
      <div className="mt-2.5 font-mono text-[0.62rem] font-bold uppercase tracking-wider text-muted">
        {label}
      </div>
      {sub != null && <div className="mt-1.5 text-xs leading-snug text-muted">{sub}</div>}
    </div>
  );
}
